export default __webpack_public_path__ + "static/media/social-distancing.b0a5f0e1.png";